<template>
    <PopoverRight ref="popoverContent" width="700px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">编辑统计代码</h1>
            <el-form class="form-container" :rules="rules" :model="formList" ref="statisticsValidateForm"> 
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">站点名称:</span>
                    </div>
                    <div class="form-input-item">
                        {{siteName}}
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">统计代码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item  prop="content">
                            <el-input type="textarea" :rows="2" v-model="formList.content" placeholder=""></el-input>                   
                        </el-form-item>
                    </div>
                </div>
                <div class="align-center">
                    <el-button @click="hideMenu">取消</el-button>
                    <el-button type="primary" @click="submitForm('statisticsValidateForm')" >确定</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import { editStatisCodes } from "@/service/site";
export default {
    name: 'edit',
    components: {
        PopoverRight,
    },
    props: {
        callback: Function,
    },
    data () {
        return {
            siteId:"",
            siteName:"",
            formList:{
                content:""
            },
            rules: {
                content: [
                    { required: true, message:'统计代码不能为空', trigger: 'blur' },
                ],
               
            },
            user:""
        }
    },
    watch: {
        checkedSite: function () {
        if (
            this.checkedSite.length == this.siteList.length &&
            this.checkedSite.length > 0
        ) {
            this.checkAll = true;
        } else {
            this.checkAll = false;
        }
        },
    },

    mounted(){
    },
    methods: {
        /** 打开右侧悬浮层 */
        openMenu (data) {
            this.siteId = data.id;
            this.siteName = data.name
            this.formList.content = data.content
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.resetForm()
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
            this.$refs.statisticsValidateForm && this.$refs.statisticsValidateForm.clearValidate()
        },
        resetForm () {
            this.formList = {
                content:""
            }
        },
        submitForm (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    editStatisCodes(this.siteId,this.formList).then((data) => {
                        this.$message({
                            message: '编辑成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.hideMenu()
                        this.callback && this.callback();
                    }).catch(err => {
                        this.$message({
                            message: err.message || '编辑失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                    
                } else {
                    return false
                }
            })
        },
    }
}
</script>
<style scoped>
.site-sp {
  display: block !important;
  padding-left: 30px;
}
.site-label {
  width: 100%;
  height: 30px;
}
.site-label .ipt {
  margin-right: 20px;
}
.form-input-site {
  min-height: 100px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 20px;
  box-sizing: border-box;
}
.form-input-site label {
  margin-right: 15px;
  padding-bottom: 10px;
  display: inline-block;
}
.form-input-site label input {
  margin-right: 5px;
}
.popover-slider-bar .form-container .form-item .form-label {
    width: 15%;
}
.popover-slider-bar .form-container .form-item .form-input-item {
    width: 75%;
}
.tips-wrapper{
    width: 100%;
    margin-top:20px;
}
.tips-wrapper .left{
    width: 15%; 
    float: left;
    text-align: right;
    line-height:30px;
}
.tips-wrapper .right{
     float: left;
     width:85%;
}
.tips-wrapper .right p{
    line-height: 30px;
}
</style>